import { MaximumLengthValidationRule } from './rules/max-length.rule';
import { MaximumValidationRule } from './rules/max.rule';
import { MinimumLengthValidationRule } from './rules/min-length.rule';
import { NotEqualToValidationRule } from './rules/not-equal-to.rule';
import { EqualToValidationRule } from './rules/equal-to.rule';
import { MinimumValidationRule } from './rules/min.rule';
import { PatternValidationRule } from './rules/pattern.rule';
import { RequiredTrueValidationRule } from './rules/required-true.rule';
import { RequiredValidationRule } from './rules/required.rule';
import { ValidationResult } from './validationresult';
import { ValidationRule } from './validation.rule';
import { DateRangeValidationRule } from './rules/date-range.rule';
import { OlderThan18ValidationRule } from './rules/older-than-18.rule';
import { LengthValidationRule } from './rules/length.rule';

export class ValidationGroup {
  private validationRules: ValidationRule[] = [];

  mustBeRequired(key: string | null = null): ValidationGroup {
    const rule = new RequiredValidationRule(key!);
    this.validationRules.push(rule);
    return this;
  }

  mustBeTrue(): ValidationGroup {
    const rule = new RequiredTrueValidationRule();
    this.validationRules.push(rule);
    return this;
  }

  maximumOf(value: number, key: string | null = null): ValidationGroup {
    const rule = new MaximumValidationRule(value, key);
    this.validationRules.push(rule);
    return this;
  }

  maximumLengthOf(value: number, key: string | null = null): ValidationGroup {
    const rule = new MaximumLengthValidationRule(value, key);
    this.validationRules.push(rule);
    return this;
  }

  lengthOf(value: number, key: string | null = null): ValidationGroup {
    const rule = new LengthValidationRule(value, key);
    this.validationRules.push(rule);
    return this;
  }

  minimumOf(value: number, key: string | null = null): ValidationGroup {
    const rule = new MinimumValidationRule(value, key);
    this.validationRules.push(rule);
    return this;
  }

  minimumLengthOf(value: number, key: string | null = null): ValidationGroup {
    const rule = new MinimumLengthValidationRule(value, key!);
    this.validationRules.push(rule);
    return this;
  }

  notEqualTo(value: any, key: string | null = null): ValidationGroup {
    const rule = new NotEqualToValidationRule(value, key!);
    this.validationRules.push(rule);
    return this;
  }

  equalTo(value: any, key: string | null = null): ValidationGroup {
    const rule = new EqualToValidationRule(value, key!);
    this.validationRules.push(rule);
    return this;
  }

  mustMatchPattern(pattern: string, key: string | null = null): ValidationGroup {
    const regex = new RegExp(pattern);
    const rule = new PatternValidationRule(regex, key);
    this.validationRules.push(rule);
    return this;
  }

  mustBeInDateRange(fromDate: Date, toDate: Date, key: string | null = null): ValidationGroup {
    const rule = new DateRangeValidationRule(key!, fromDate, toDate);
    this.validationRules.push(rule);
    return this;
  }

  mustBeOlderThan18Years(key: string | null = null): ValidationGroup {
    const rule = new OlderThan18ValidationRule(key!);
    this.validationRules.push(rule);
    return this;
  }

  spliceRule(key: string): void {
    const ruleType = this.validationRules.find((r) => r.key === key);
    if (!ruleType) {
      return;
    }

    const index = this.validationRules.indexOf(ruleType);
    if (index === -1) {
      return;
    }
    this.validationRules.splice(index, 1);
  }

  addRule(key: string, rule: ValidationRule): void {
    const ruleType = this.validationRules.find((r) => r.key === key);
    if (ruleType) {
      return;
    }

    this.validationRules.push(rule);
  }

  clone(): ValidationGroup {
    const validationGroup = new ValidationGroup();
    validationGroup.validationRules.push(...this.validationRules);

    return validationGroup;
  }

  validate(value: any): ValidationResult {
    const result = new ValidationResult();
    this.validationRules.forEach((rule) => {
      const isValid = rule.isValid(value);

      if (!isValid) {
        result.failed(rule);
      }
    });
    return result;
  }
}
